import { combineReducers } from 'redux';

import { SET_VIEW_MODE } from '../state/site/actions';
import WixEvents from '../state/wix-events';
import createReducer from '../services/create-reducer';

const byId = (state = null) => state;
const ids = (state = null) => state;
const memberCountById = (state = null) => state;

const isEditingBadges = createReducer(false, {
  [WixEvents.BADGES_PREVIEW_OPEN]: () => true,
  [WixEvents.BADGES_PREVIEW_CLOSE]: () => false,
  [SET_VIEW_MODE]: () => false,
});

export default combineReducers({
  byId,
  ids,
  memberCountById,
  isEditingBadges,
});
